import { type Currency } from '@/core/localization/interfaces/Currency';
import { type Currency as PriceCurrency } from '@/core/tamagoshi/deprecated/PriceDeprecated/PriceDeprecated';
import { getAppSetting } from '@/domains/core/settings/appSettings';

export const FAQS_POST_ID = 360014300618;

export const TOTAL_MODELS_LIMIT = 100;

export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  EUR: '€',
  GBP: '£',
};

export const CURRENCY_NAMES: Record<Currency, PriceCurrency> = {
  EUR: 'EURO',
  GBP: 'POUND_STERLING',
};

export const EXCLUDED_MEASUREMENT = 'piece';

export const B2B_BULK_PURCHASE_URL =
  getAppSetting('B2B_BULK_PURCHASE_URL_CLIENT') ??
  'https://hooks.zapier.com/hooks/catch/12013067/blert04/';
